import React from "react"
import { ThemeProvider } from "@mui/material/styles"
import theme from "./src/theme"

// custom typefaces
import "@fontsource/poppins/300.css" // Specify weight
import "@fontsource/merriweather"
// Blog-specific typography
import "@fontsource/oswald/400.css"
import "@fontsource/oswald/600.css"
import "@fontsource/oswald/700.css"
import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

export const wrapRootElement = ({ element }) => (
  <ThemeProvider theme={theme}>{element}</ThemeProvider>
)
